import { Injectable } from '@angular/core'
import { SyncPairAccessDto, SyncPairInfo } from '../../services/dtos'

// testSyncPairAccess assumes a role in both endpoints, which is why it gets a
// full-page "Checking for AWS connectivity" spinner. The template-choice step and
// the connect page are consecutive screens over the same result, so whichever runs
// the check hands it to the next one instead of making the customer wait twice.
// In-memory only, and short-lived: a refresh or a slow customer just re-checks.
const TTL_MS = 2 * 60 * 1000

@Injectable({
  providedIn: 'root',
})
export class SyncPairAccessCache {
  private key: string = null
  private dto: SyncPairAccessDto = null
  private fetchedAt = 0

  put(pair: SyncPairInfo, dto: SyncPairAccessDto): void {
    this.key = this.buildKey(pair)
    this.dto = dto
    this.fetchedAt = Date.now()
  }

  get(pair: SyncPairInfo): SyncPairAccessDto {
    if (!this.dto || this.key !== this.buildKey(pair)) {
      return null
    }
    if (Date.now() - this.fetchedAt > TTL_MS) {
      this.clear()
      return null
    }
    return this.dto
  }

  clear(): void {
    this.key = null
    this.dto = null
    this.fetchedAt = 0
  }

  // accountId is part of the key because access is granted per Arpio account: the same
  // AWS pair registered in two accounts must not read each other's verdict.
  private buildKey(pair: SyncPairInfo): string {
    return [pair?.accountId, pair?.sourceEndpointUri, pair?.targetEndpointUri, pair?.identityProviderId].join('|')
  }
}
